/* custom-gallery.js
   Additive product-gallery enhancement. Loaded from sections/main-product.liquid.
   Adds hover-activated prev/next arrows on the MAIN product image that cycle
   through all product media with wraparound, reusing Dawn's native
   media-gallery.setActiveMedia(). Does not modify any Dawn core files.
   Fully reversible: delete this file, its <script> tag, custom-gallery.css and
   its stylesheet_tag. */
(function () {
  'use strict';

  var CARET =
    '<span class="svg-wrapper"><svg viewBox="0 0 10 6" width="10" height="6" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646A.5.5 0 0 0 .646 1.354l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" fill="currentColor"></path></svg></span>';

  function enhance(gallery) {
    if (!gallery || gallery.__customEnhanced) return;
    var viewer = gallery.querySelector('slider-component:not(.thumbnail-slider)');
    var list = viewer && viewer.querySelector('ul.product__media-list, ul[id^="Slider-Gallery"]');
    if (!viewer || !list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('li.product__media-item'));
    if (items.length < 2) return;
    gallery.__customEnhanced = true;
    viewer.classList.add('custom-main-viewer');

    function currentIndex() {
      var active = list.querySelector('.product__media-item.is-active');
      return active ? items.indexOf(active) : 0;
    }
    function go(delta) {
      var n = items.length;
      var idx = (currentIndex() + delta + n) % n; // wraparound
      var id = items[idx].getAttribute('data-media-id');
      if (id && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(id, true);
        if (typeof gallery.setActiveThumbnail === 'function') {
          try { gallery.setActiveThumbnail(id); } catch (e) {}
        }
      }
    }
    function makeArrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'custom-main-arrows custom-main-arrows--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      b.innerHTML = CARET;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(dir === 'prev' ? -1 : 1);
      });
      return b;
    }

    if (getComputedStyle(viewer).position === 'static') viewer.style.position = 'relative';
    viewer.appendChild(makeArrow('prev'));
    viewer.appendChild(makeArrow('next'));
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
